import LocalStorageMixin from '@virgodev/bazaar/mixins/localstorage';
import WebsocketMixin from '@virgodev/bazaar/mixins/websockets';
import debug from 'debug';

const log = debug('chat');


export default {
  name: 'ChatAppMixin',
  mixins: [WebsocketMixin, LocalStorageMixin],
  data() {
    return {
      chatConversationsLimit: 30,
      chatConversations: [],
      chatRead: [],
      localStoragePrefix: 'chat:',
      personalStatus: this.get('status', 'unknown'),
    };
  },
  async mounted() {
    this.$root.$on(`ws:_message_`, async data => {

      if (data.type === 'join') {
        await this.onJoinedRoom(data);
      }

      // send to app level handlers
      if (data.mid) {
        // response
      } else if (data.type === 'chat_message') {
        await this.onChatMessage(data);
      } else if (data.type === 'leave') {
        await this.onLeftRoom(data);
      } else if (data.type === 'room_update') {
        await this.onRoomUpdated(data);
      } else if (data.type === 'chat_status') {
        await this.onChatStatusUpdated(data);
      } else if (data.type === '♥') {
        // console.log('♥');
      } else if (data.type === 'login') {
        // pass
      } else {
        log(`unknown message:`, data.type, data);
      }
    });
    this.$root.$on('ws:login', () => {
      this.loadChatConversations();
    });
  },
  methods: {
    async markChatRead(id) {
      this.$emit('chat:read', id);

      if (!this.chatRead.find(i => i === id)) {
        this.chatRead.push(id);
        if (this.chatRead.length > this.chatConversationsLimit) {
          this.chatRead.shift();
        }
      }
      return this.sendOnWebsocket({
        type: 'chat_message_ack',
        id,
      });
    },

    async loadChatConversations() {
      const response = await this.api({
        url: `chat/conversations/?limit=${this.chatConversationsLimit}`,
      });
      if (response.ok) {
        this.chatConversations = response.body;
      }
    },

    // eslint-disable-next-line no-unused-vars
    async onChatMessage(chat) {
      let existing = this.chatConversations.find(c => c.room === chat.room);
      if (existing) {
        existing.last_message = chat;
        existing.read = chat.transport !== 'pm';
      } else {
        this.chatConversations.push({
          room: chat.room,
          read: chat.transport !== 'pm',
          last_message: chat,
        });
      }
      if (this.chatConversations.length > this.chatConversationsLimit) {
        this.chatConversations.shift();
      }
    },

    // eslint-disable-next-line no-unused-vars
    onJoinedRoom(data) {
      // mark conversations as read
      const convIndex = this.chatConversations.findIndex(c => c.room === data.room);
      if (convIndex !== -1 && !this.chatConversations[convIndex].read) {
        this.chatConversations[convIndex].read = true;
        this.markChatRead(this.chatConversations[convIndex].last_message.id);
      }
    },

    // eslint-disable-next-line no-unused-vars
    onLeftRoom(data) {},

    // eslint-disable-next-line no-unused-vars
    onRoomUpdated(data) {},

    // eslint-disable-next-line no-unused-vars
    onChatStatusUpdated(data) {},
  },
};

